'use client'

import React, { useRef } from 'react'
import styles from './ClearableTextInput.module.scss'
import { ClearableTextInputProps } from './ClearableTextInput.interface'

const ClearableTextInput: React.FC<ClearableTextInputProps> = ({
  value,
  onChange,
  inputClassName,
  containerClassName,
  clearButtonAriaLabel = 'Clear input',
  clearable = true,
  trailingAdornment,
  autoFocus,
  onFocus,
  ...inputProps
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const showClearButton = clearable && value.length > 0

  const handleClear = () => {
    onChange('')
    inputRef.current?.focus()
  }

  return (
    <div className={`${styles.container} ${containerClassName ?? ''}`.trim()}>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${inputClassName ?? ''} ${showClearButton ? styles.inputWithClear : ''}`.trim()}
        autoFocus={autoFocus}
        onFocus={onFocus}
        {...inputProps}
      />
      {showClearButton ? (
        <button
          type="button"
          className={styles.clearButton}
          onClick={handleClear}
          aria-label={clearButtonAriaLabel}
        >
          <span className={styles.clearIcon} aria-hidden="true">
            ×
          </span>
        </button>
      ) : (
        trailingAdornment
      )}
    </div>
  )
}

export default ClearableTextInput
